import Cookies from 'universal-cookie'

// Cookies
export const cookies = new Cookies()



// WEBPACK FOOTER //
// ./src/utils.js